export default "/images/7d9b09fc5e5ed485f79dc7e0986a662f.avif";